

/**
 * API Request handler
 * @param url - api endpoint
 * @param method - http method
 * @param bodyParams - body parameters of request
 */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc)

const showDate = (date) => {
    const mdate = dayjs(date);
    return mdate.format('DD-MMM-YYYY');

}

const showTime = (date) => {
    const mdate = dayjs(date);
    return mdate.format("HH:mm");

}

const showDateTime = (date) => {
    const mdate = dayjs(date);
    return mdate.format('DD-MMM-YYYY') + ' ' + mdate.format("HH:mm");

}

const showDateUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format('DD-MMM-YYYY');

}

const showTimeUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format("HH:mm");

}

const showDateTimeUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format('DD-MMM-YYYY') + ' ' + mdate.local().format("HH:mm");

}

// UTF-8 safe Base64 encode function
const base64Encode = (str) => {
    const utf8Bytes = new TextEncoder().encode(str);
    let binary = "";
    utf8Bytes.forEach((b) => (binary += String.fromCharCode(b)));
    return btoa(binary);
}

// These API actions decode the legacy encodedData request envelope on the server.
const encodedRequestEndpoints = [
    "sendemails",
    "newbid",
    "aircraft/add",
    "aircraft/update",
    "newcharterrequest",
    "clonecharterrequest",
    "updatecharterrequest",
    "updatechangecharter",
    "updatemanifest",
    "newchangecharter",
    "updatechartershare",
    "updatechartersharepurchase",
    "updateterms",
];

const encodeRequestBody = (url, requestBody) => {
    if (url && encodedRequestEndpoints.some(endpoint => url.toLowerCase().includes(endpoint))) {
        return JSON.stringify({ encodedData: base64Encode(requestBody) });
    }

    return requestBody;
}

// Money with two decimals, e.g. 3,380.50
const showPrice = (value) => Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export { showDate, showTime, showDateTime, showDateUTC, showTimeUTC, showDateTimeUTC, showPrice, base64Encode, encodeRequestBody };